// libs
import React, { memo } from 'react';

// styles
import {
  Container,
  SubTitle,
  AnchorTitle,
  TextTitle,
  AnchorVisitStore,
  TitleWrapper,
} from './styles';

// helpers
import { storeAnalyticsDataInLocal } from 'shared/helpers/storage/storeData';
import { trackBrandNameClicked } from 'shared/layouts/DetailsPage/analytics';

// constants
import { BRAND_CLICK_TRACK_LOCATION } from 'shared/helpers/analytics/constants/pdpEvents';

const VISIT_STORE = 'Visit Store';

// defs
interface ITitleProps {
  title: string;
  subTitle: string;
  actionUrl?: string;
}

function Title({ title, subTitle, actionUrl }: ITitleProps) {
  const onBrandTitleClicked = () => {
    if (actionUrl == undefined) {
      return;
    }
    storeAnalyticsDataInLocal({ brandTitleOrAboutUs: 'brandTitle' });
    trackBrandNameClicked(BRAND_CLICK_TRACK_LOCATION.TITLE_CLICK);
  };

  const BRAND_TITLE = actionUrl ? (
    <AnchorTitle href={actionUrl} data-test="brand-url" onClick={onBrandTitleClicked}>
      {title}
    </AnchorTitle>
  ) : (
    <TextTitle data-test="brand-title">{title}</TextTitle>
  );

  return (
    <Container data-test="title">
      <TitleWrapper data-at="product-name">
        {BRAND_TITLE}
        <SubTitle data-test="sub-title">{subTitle}</SubTitle>
      </TitleWrapper>
      {actionUrl && (
        <AnchorVisitStore
          href={actionUrl}
          onClick={() => trackBrandNameClicked(BRAND_CLICK_TRACK_LOCATION.VIEW_BRAND_CTA)}
          data-test="visit-store-anchor"
        >
          {VISIT_STORE}
        </AnchorVisitStore>
      )}
    </Container>
  );
}

export default memo(Title);
